import Highcharts from 'highcharts';
import 'highcharts/modules/wordcloud';

const seededRandom = (seed) => {
  // Park–Miller LCG requires an integer seed in [1, 2147483646]
  let value = Math.floor(Number(seed)) % 2147483647;
  if (value <= 0) value += 2147483646;

  return () => {
    value = (value * 16807) % 2147483647;
    return (value - 1) / 2147483647;
  };
};

// Cache RNG streams by seed to avoid bias from re-seeding per point
const rngStreamCache = {};

Highcharts.seriesTypes.wordcloud.prototype.placementStrategy.customRandom = (point, options) => {
  const { field } = options;

  const radiusX = field.width * 0.2;
  const radiusY = field.height * 0.2;

  const seed = point.series.options.custom?.seed ?? 1;

  // Use shared RNG stream for all points within a single cloud
  if (!rngStreamCache[seed]) {
    rngStreamCache[seed] = seededRandom(seed);
  }
  const random = rngStreamCache[seed];

  return {
    rotation: 0,
    x: random() * radiusX * 2 - radiusX,
    y: random() * radiusY * 2 - radiusY,
  };
};

export const WORD_CLOUD_SERIES_BASE = {
  maxFontSize: 80,
  minFontSize: 14,
  name: 'Occurrences',
  placementStrategy: 'customRandom',
  rotation: { from: 0, to: 0 },
  type: 'wordcloud',
};

export const buildWordCloudChartOptions = ({
  creditsEnabled = false,
  data,
  exportingEnabled = false,
  seriesOptions = {},
  titleText = undefined,
  tooltipEnabled = true,
} = {}) => ({
  credits: { enabled: creditsEnabled },
  exporting: { enabled: exportingEnabled },
  series: [
    {
      ...WORD_CLOUD_SERIES_BASE,
      ...seriesOptions,
      data,
    },
  ],
  title: { text: titleText },
  tooltip: { enabled: tooltipEnabled },
});

export const shuffleCopy = (array, seed) => {
  const random = seededRandom(seed);
  const copy = array.map((point) => ({ ...point }));

  for (let i = copy.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }

  return copy;
};
